/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class CsvService {

  constructor() {}

  convertToCsvUrl(objArray, keyList, headerList) {
    let array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';

    // tslint:disable-next-line:forin
    for (let index in headerList) {
      row += headerList[index] + ',';
    }

    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';

      // tslint:disable-next-line:forin
      for (let index in keyList) {
        let key = keyList[index];

        line += array[i][key] + ',';
      }
      line = line.slice(0, -1);
      str += line + '\r\n';
    }

    let blob: any = new Blob(['\ufeff' + str], {type: 'text/csv;charset=utf-8;'});
    return URL.createObjectURL(blob);
  }

  flatten(obj: Record<string, any>, keys = [], separator = '.') {
    return Object.keys(obj).reduce((memo, prop): Record<string, any> => {
      const value = obj[prop.toString()];
      const nextKeys = keys.concat([prop] as any);
      const isObject = _.isObject(value);

      if (isObject) {
        return {
          ...memo,
          ...this.flatten(value, nextKeys, separator)
        };
      }

      return { ...memo, [nextKeys.join(separator)]: value };
    }, {});
  }
}
